export default __webpack_public_path__ + "static/media/university.bf1a626b.jpg";